import { subscribeChannel, publishChannel } from './channelUtils';

export function sendHourRange(payload) {
    
    publishChannel('hour-range-upsert', payload);

}

export function listenHourRange(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (tipo !== 'hour-range-upsert') {
            return;
        }

        callback({ tipo, payload });

    });

}